// components/ComedianteTable.jsx
import React from 'react';
import { FaEdit, FaToggleOn, FaToggleOff, FaVideo, FaUser, FaEnvelope } from 'react-icons/fa';
import sinFoto from '../../../../../images/sin-foto.png';

const ComedianteTable = ({ comediantes, onEdit, onToggleStatus }) => {
  return (
    <div className="overflow-x-auto rounded-lg shadow">
      <table className="min-w-full bg-zinc-800 divide-y divide-zinc-700">
        <thead>
          <tr>
            <th className="px-6 py-3 bg-zinc-700 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              Comediante
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              Usuario Asociado
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              Biografía
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              Actividad
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-center text-xs font-medium text-gray-300 uppercase tracking-wider">
              Estado
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-right text-xs font-medium text-gray-300 uppercase tracking-wider">
              Acciones
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-zinc-700">
          {comediantes.length > 0 ? (
            comediantes.map((comediante) => (
              <tr key={comediante.comedianteId} className={`hover:bg-zinc-700 transition-colors ${!comediante.habilitado ? 'opacity-60' : ''}`}>
                <td className="px-6 py-4">
                  <div className="flex items-center">
                    <div className="flex-shrink-0 h-16 w-16 bg-zinc-700 rounded-full overflow-hidden">
                      <img
                        src={
                          comediante.imagen && comediante.imagen.trim() !== ''
                            ? comediante.imagen
                            : sinFoto
                        }
                        alt={comediante.nombre}
                        className="h-full w-full object-cover"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = sinFoto;
                        }}
                      />

                    </div>
                    <div className="ml-4">
                      <div className="text-sm font-medium text-white">{comediante.nombre}</div>
                    </div>
                  </div>
                </td>
                
                {/* Nueva columna para Usuario Asociado */}
                <td className="px-6 py-4">
                  <div className="text-sm">
                    {comediante.usuarioNombre ? (
                      <div className="space-y-1">
                        <div className="flex items-center text-white">
                          <FaUser className="mr-2 text-gray-400 text-xs" />
                          <span className="font-medium">{comediante.usuarioNombre}</span>
                        </div>
                        <div className="flex items-center text-gray-400">
                          <FaEnvelope className="mr-2 text-xs" />
                          <span className="text-xs">{comediante.usuarioEmail}</span>
                        </div>
                      </div>
                    ) : (
                      <div className="flex items-center text-gray-500">
                        <FaUser className="mr-2 text-xs" />
                        <span className="text-xs italic">Sin usuario asociado</span>
                      </div>
                    )}
                  </div>
                </td>
                
                <td className="px-6 py-4">
                  <div className="text-sm text-gray-300 max-w-xs">
                    <p className="truncate" title={comediante.biografia || "Sin biografía"}>
                      {comediante.biografia || "Sin biografía"}
                    </p>
                  </div>
                </td>
                
                <td className="px-6 py-4">
                  <div className="text-sm text-white">
                    <div className="flex items-center">
                      <FaVideo className="mr-1 text-gray-400" />
                      <span>{comediante.cantidadShows || 0} shows</span>
                    </div>
                  </div>
                </td>
                
                <td className="px-6 py-4 text-center">
                  <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium 
                    ${comediante.habilitado 
                      ? 'bg-green-100 text-green-800' 
                      : 'bg-red-100 text-red-800'}`}
                  >
                    {comediante.habilitado ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <div className="flex justify-end space-x-2">
                    <button
                      onClick={() => onEdit(comediante)}
                      className="p-1 rounded bg-blue-100 text-blue-600 hover:bg-blue-200"
                      title="Editar comediante"
                    >
                      <FaEdit />
                    </button>
                    <button
                      onClick={() => onToggleStatus(comediante)}
                      className={`p-1 rounded ${comediante.habilitado 
                        ? 'bg-red-100 text-red-600 hover:bg-red-200' 
                        : 'bg-green-100 text-green-600 hover:bg-green-200'}`}
                      title={comediante.habilitado ? "Deshabilitar comediante" : "Habilitar comediante"}
                    >
                      {comediante.habilitado ? <FaToggleOff /> : <FaToggleOn />}
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="px-6 py-12 text-center text-gray-400">
                No se encontraron comediantes que coincidan con la búsqueda.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ComedianteTable;